import {Component, OnInit} from '@angular/core';
import {MEAPeriodTypes, NewSimulationService} from '../new-simulation.service';
import {Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';
import {IMyDrpOptions} from 'mydaterangepicker';

@Component({
  selector: 'app-mea-selection',
  templateUrl: './mea-selection.component.html',
  styleUrls: ['./mea-selection.component.css']
})
export class MeaSelectionComponent implements OnInit {

  public section: any;
  public regions = [];
  public countries = [];
  public currencies = [];

  private defaultCurrencyies = [
    {
      Currency_code: 'EUR'
    },
    {
      Currency_code: 'USD'
    }
  ]

  public meaForm = this.formBuilder.group({
    region: [''],
    country: [''],
    contractingPartner: [''],
    currency: [''],
    startEndDate : [''],
    numberOfMEAPeriods: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
    agreementType : ['', Validators.required]
  });

  public myDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: 'dd.mm.yyyy',
  };

  constructor(private formBuilder: FormBuilder, private service: NewSimulationService, private router: Router) {
    this.section = service.sections[1];
  }

  ngOnInit() {
    if (!this.service.sections[0].completed) {
      this.router.navigate(['/new-simulation/product-information']);
    }

    this.currencies = [];
    this.currencies = this.currencies.concat(this.defaultCurrencyies);

    const that = this;

    if(!this.section.data[0]){
      this.section.data.push(new MEAEntity());
    }
    this.service.fetchRegions()
        .subscribe((regions) => {
          that.regions = regions;
        });
  }

  public onRegionSelect(region) {

    const that = this;

    this.service.fetchCountriesByRegion(region)
        .subscribe((countries) => {
          that.countries = countries;
        });
  }

  public onCountrySelect(country) {

    let that = this;

    this.currencies = [];
    this.currencies = this.currencies.concat(this.defaultCurrencyies);

    this.service.fetchCurrencyByCountry(country)
        .subscribe((currencies) => {
          for(let currency of currencies) {
            if(!that.currencies.find((x) => {
                return x.Currency_code ===currency.Currency_code;
            })) {
              that.currencies.push(currency);
            }
          }
        });
  }

  onNextClicked() {
    this.section.completed = true;
    this.router.navigate(['/new-simulation/simulation-input']);
  }

}

export class MEAEntity {
  public region: string;
  public country: string;
  public contractingPartner: string;
  public currency: string;
  public startEndDate : any;
  public numberOfMEAPeriods: string;
  public agreementType : MEAPeriodTypes;
}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/mea-selection/mea-selection.component.ts